module.exports = __webpack_public_path__ + "img/camping-locked.ced9f4b4.png";